/**
 * Shape esperado: array flat con totalSpent, avgOrderValue, ordersCount, etc.
 * El handler del router lo devuelve junto con `stats` agregadas.
 */
export const CUSTOMERS_DEMO = [
  {
    id: 'cus_01', email: 'cliente1@gmail.com', firstName: 'Sebastián', lastName: 'Lozano', phone: '3213613163', isActive: true,
    totalSpent: 1_215_000, avgOrderValue: 243_000, ordersCount: 5, paidOrdersCount: 5, cancelledCount: 0,
    lastOrderAt: '2026-05-08T14:35:00.000Z', createdAt: '2025-12-04T10:00:00.000Z',
  },
  {
    id: 'cus_02', email: 'maria@example.com', firstName: 'María', lastName: 'Ortiz', phone: '3001234567', isActive: true,
    totalSpent: 720_000, avgOrderValue: 240_000, ordersCount: 3, paidOrdersCount: 2, cancelledCount: 1,
    lastOrderAt: '2026-04-22T11:00:00.000Z', createdAt: '2026-01-15T11:00:00.000Z',
  },
  {
    id: 'cus_03', email: 'andres@example.com', firstName: 'Andrés', lastName: 'Pérez', phone: '3014567890', isActive: true,
    totalSpent: 2_980_000, avgOrderValue: 372_500, ordersCount: 8, paidOrdersCount: 8, cancelledCount: 0,
    lastOrderAt: '2026-05-07T16:00:00.000Z', createdAt: '2025-10-20T09:00:00.000Z',
  },
  {
    id: 'cus_04', email: 'lina@example.com', firstName: 'Lina', lastName: 'Castro', phone: '3201112233', isActive: true,
    totalSpent: 410_000, avgOrderValue: 205_000, ordersCount: 2, paidOrdersCount: 2, cancelledCount: 0,
    lastOrderAt: '2026-05-05T11:00:00.000Z', createdAt: '2026-02-14T12:00:00.000Z',
  },
  {
    id: 'cus_05', email: 'sofia@example.com', firstName: 'Sofía', lastName: 'Rodríguez', phone: '3002345678', isActive: true,
    totalSpent: 3_510_000, avgOrderValue: 292_500, ordersCount: 12, paidOrdersCount: 11, cancelledCount: 1,
    lastOrderAt: '2026-05-03T20:00:00.000Z', createdAt: '2025-09-08T08:00:00.000Z',
  },
  {
    id: 'cus_06', email: 'jhon@example.com', firstName: 'Jhon', lastName: 'Doe', phone: '3009876543', isActive: false,
    totalSpent: 95_000, avgOrderValue: 95_000, ordersCount: 1, paidOrdersCount: 1, cancelledCount: 0,
    lastOrderAt: '2026-04-18T16:00:00.000Z', createdAt: '2026-04-18T16:00:00.000Z',
  },
  {
    id: 'cus_07', email: 'ricardo@example.com', firstName: 'Ricardo', lastName: 'Méndez', phone: '3008273611', isActive: true,
    totalSpent: 540_000, avgOrderValue: 270_000, ordersCount: 2, paidOrdersCount: 2, cancelledCount: 0,
    lastOrderAt: '2026-05-01T10:00:00.000Z', createdAt: '2026-03-12T11:00:00.000Z',
  },
  {
    id: 'cus_08', email: 'valentina@example.com', firstName: 'Valentina', lastName: 'Mora', phone: '3142345600', isActive: true,
    totalSpent: 195_000, avgOrderValue: 195_000, ordersCount: 1, paidOrdersCount: 1, cancelledCount: 0,
    lastOrderAt: '2026-04-30T15:00:00.000Z', createdAt: '2026-04-30T15:00:00.000Z',
  },
]
